// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3Pe4I","errorLogs":"styles_errorLogs__-3tTS"};